<div class="e11-mt-12 e11-border-t e11-border-gray-200 e11-pt-8">
  <p class="e11-text-base e11-text-gray-400">© {{ yearCurrent }} Cnect, Inc. {{ 'All rights reserved.' | translate }}</p>
</div>
